{
  "appName": "Grupa RW",
  "loading": "Ładowanie...",
  "nav": {
    "dashboard": "Pulpit",
    "mediaUnits": "Katalog nośników",
    "map": "Mapa",
    "offers": "Oferty",
    "clients": "Klienci",
    "suppliers": "Dostawcy",
    "reservations": "Rezerwacje",
    "packages": "Pakiety",
    "draft": "Szkic",
    "comingSoon": "Wkrótce",
    "noAccess": "Brak dostępu",
    "admin": "Admin",
    "adminPois": "Punkty zainteresowania",
    "logout": "Wyloguj się",
    "user": "Użytkownik"
  },
  "sidebar": {
    "collapse": "Zwiń",
    "expand": "Rozwiń",
    "ariaLabel": "Nawigacja boczna",
    "mainMenu": "Menu główne"
  },
  "language": {
    "switchLabel": "Zmień język",
    "pl": "Polski",
    "en": "English"
  },
  "appUpdate": {
    "title": "Dostępna jest nowa wersja",
    "message": "Odśwież stronę, aby zobaczyć najnowsze zmiany. Pozostaniesz zalogowany.",
    "reload": "Odśwież"
  },
  "actions": {
    "save": "Zapisz nośnik",
    "saving": "Zapisywanie...",
    "saved": "Zapisano!",
    "saveError": "Błąd zapisu",
    "saveChanges": "Zapisz zmiany",
    "saveConfirm": "Zapisz",
    "cancel": "Anuluj",
    "retry": "Spróbuj ponownie",
    "backToCatalog": "Katalog nośników",
    "backToDetail": "Szczegóły nośnika"
  },
  "status": {
    "free": "Wolne",
    "unknown": "Niepotwierdzone",
    "option": "Stałka",
    "reserved": "Zarezerwowane",
    "reservedSoft": "Miękka rezerwacja",
    "reservedHard": "Twarda rezerwacja",
    "sold": "Sprzedane",
    "unavailable": "Niedostępne"
  },
  "bool": {
    "yes": "Tak",
    "no": "Nie"
  },
  "errors": {
    "loadFailed": "Nie udało się załadować nośników",
    "notFound": "Nie znaleziono nośnika",
    "loadUnitFailed": "Nie udało się załadować nośnika",
    "backToCatalog": "Wróć do katalogu"
  },
  "error": {
    "generic": "Wystąpił błąd",
    "notFound": "Nie znaleziono strony",
    "retry": "Spróbuj ponownie",
    "goBack": "Wróć",
    "details": "Szczegóły błędu"
  },
  "quickAdd": {
    "toast": {
      "standard": "Dodano {{addedCount}} do: {{offerName}} — {{totalCount}} łącznie, {{skippedCount}} pominięte",
      "allSkipped": "0 dodanych — wszystkie już w ofercie: {{offerName}} — {{totalCount}} łącznie, {{skippedCount}} pominięte",
      "openOffer": "Otwórz ofertę"
    },
    "errors": {
      "forbidden": "Brak uprawnień do tej oferty roboczej",
      "creationForbidden": "Nie udało się utworzyć oferty — brak uprawnień do wykonania tej operacji.",
      "campaignNumberExhausted": "Nie udało się wygenerować unikalnego numeru kampanii. Spróbuj ponownie.",
      "addUnitsFailedAfterCreate": "Nie udało się dodać nośników do nowo utworzonej oferty roboczej."
    }
  },
  "notifications": {
    "bellLabel": "Powiadomienia",
    "markAllRead": "Oznacz wszystkie jako przeczytane",
    "emptyState": "Brak powiadomień",
    "ttlExpiring": "Wygasa za {{count}} rezerwacji oferty",
    "ttlExpired": "Wygasło {{count}} rezerwacji oferty",
    "queuePromoted": "{{count}} rezerwacji z kolejki awansowało",
    "offerVersionAccepted": "{{count}} ofert zaakceptowanych przez klienta",
    "offerVersionRejected": "{{count}} ofert odrzuconych przez klienta"
  },
  "apiErrors": {
    "generic": "Coś poszło nie tak. Spróbuj ponownie.",
    "validationError": "Dane w formularzu są nieprawidłowe. Sprawdź wprowadzone wartości.",
    "queryValidationError": "Nie udało się wczytać części danych. Spróbuj odświeżyć stronę.",
    "unauthorized": "Sesja wygasła. Zaloguj się ponownie.",
    "forbidden": "Nie masz uprawnień do wykonania tej operacji.",
    "notFound": "Nie znaleziono żądanego zasobu.",
    "conflict": "Wystąpił konflikt danych. Odśwież stronę i spróbuj ponownie.",
    "rateLimited": "Zbyt wiele żądań. Spróbuj ponownie za chwilę.",
    "internalError": "Wystąpił błąd serwera. Spróbuj ponownie później.",
    "staleState": "Dane zostały zmienione przez kogoś innego. Odśwież stronę i spróbuj ponownie.",
    "reservationConflict": "Ten termin koliduje z inną rezerwacją.",
    "reservationStatusBlocked": "Tej rezerwacji nie można teraz zmienić ze względu na jej status.",
    "offerVersionSuperseded": "Ta wersja oferty została zastąpiona nowszą.",
    "publicLinkExpired": "Link do oferty wygasł.",
    "lockedDecisionModified": "Część wybranych nośników jest już wiążąca i nie można ich zmienić. Odśwież stronę i spróbuj ponownie.",
    "unsupportedFileFormat": "Nieobsługiwany format pliku. Zapisz plik w dozwolonym formacie i spróbuj ponownie."
  },
  "campaignDurationField": {
    "shortPeriodWarning": "Wybrany okres oferty jest krótszy niż 14 dni – upewnij się, że to zamierzone, gdyż większość nośników nie pozwala na rezerwacje krótsze niż 2 tygodnie."
  },
  "offerUnits": {
    "addConflictWarning_one": "{{count}} z dodanych nośników ma rezerwację kolidującą z czasem trwania kampanii.",
    "addConflictWarning_few": "{{count}} z dodanych nośników ma rezerwacje kolidujące z czasem trwania kampanii.",
    "addConflictWarning_many": "{{count}} z dodanych nośników ma rezerwacje kolidujące z czasem trwania kampanii."
  },
  "adminLanding": {
    "heading": "Panel administracyjny",
    "pois": {
      "title": "Dane geograficzne",
      "description": "Zarządzaj punktami zainteresowania (POI) i granicami administracyjnymi oraz monitoruj importy danych geograficznych."
    },
    "permissions": {
      "title": "Uprawnienia",
      "description": "Zarządzaj rolami użytkowników i macierzą uprawnień."
    },
    "users": {
      "title": "Użytkownicy",
      "description": "Zarządzaj kontami użytkowników, rolami i nadpisaniami uprawnień."
    },
    "dictionaries": {
      "title": "Słowniki",
      "description": "Zarządzaj formatami mediów i grupami formatów."
    },
    "formatGroups": {
      "title": "Grupy formatów",
      "description": "Zarządzaj grupami formatów nośników i ich przypisaniem do ról."
    },
    "tags": {
      "title": "Tagi",
      "description": "Zarządzaj definicjami tagów — tworzenie, edycja i dezaktywacja."
    },
    "featureFlags": {
      "title": "Flagi funkcji",
      "description": "Włączaj i wyłączaj funkcje systemowe bez dostępu do bazy danych."
    }
  }
}
